import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import FouGroup from 'components/layout/fou-group/'
import { SubmissionObject } from 'src/pages/submissions/script/common.data'
import { useForm } from 'vee-validate'
import { mapGetters } from 'vuex'

import Methods from './methods'
import Computed from './computed'

export default {
  name: 'dateScheduler',

  components: {
    FouGroup
  },

  data() {
    return {
      releaseOption: 1,
      releaseDate: '',
      releaseSchedule: 2,
      releaseASAP: 1,
      processing: false,
      ...SubmissionObject
    }
  },

  setup() {
    const { errors } = useForm()
    return {
      errors
    }
  },

  props: {
    description: {
      type: String,
      default: ''
    },
    errors: {
      type: Object,
      default: {}
    },
    banned: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.setValues()
    this.$events?.$on('checkForReleaseDate', () => {
      this.validationForReleaseDate()
    })
  },

  computed: {
    ...SubmissionComputed,
    ...Computed,
    ...mapGetters('graphics', ['scanStatus']),

    releaseDateErrors() {
      return Object.keys(this.errors)
        .filter(error => error.includes('release date'))
        .map(error => this.errors[error])
    }
  },

  methods: Methods
}
